import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
// 生成售后单
export default async function salesOrderList(context: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/order/sales_order/list', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  return res;
}
